/** Bundle-time index of Edit-menu SVG icons. */

import { svgToDataUrl } from "./svgInline";

const modules = import.meta.glob<string>("../assets/icons/edit/*.svg", {
  eager: true,
  query: "?raw",
  import: "default",
});

const byName: Record<string, string> = {};
for (const [path, raw] of Object.entries(modules)) {
  const name = path.split("/").pop() ?? path;
  byName[name] = svgToDataUrl(raw);
}

export function getEditIconUrl(
  name: string | undefined | null,
): string | undefined {
  if (!name) return undefined;
  return byName[name];
}
